import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Tag,
} from "@chakra-ui/react";
import React from "react";
import { Field } from "react-final-form";
import useGravityForms from "../../../hooks/use-gravity-forms";

import { gql, useMutation } from "@apollo/client";

const MUTATION = gql`
  mutation ($file: UploadInput!) {
    upload(input: $file) {
      text
    }
  }
`;

const FileUpload = ({ label, isRequired, labelPlacement, id }) => {
  const [mutate] = useMutation(MUTATION);
  const { formFileUploads, setFormFileUploads } = useGravityForms();

  return (
    <Field
      name={`id_${id}`}
      type="file"
      validate={(values) => {
        if (isRequired && !values) {
          return "Required";
        }
      }}
    >
      {({ input, meta }) => (
        <FormControl
          isInvalid={meta.error && meta.touched && !meta.active}
          position="relative"
        >
          {labelPlacement !== "HIDDEN" && <FormLabel>{label}</FormLabel>}
          {meta.error && meta.touched && !meta.active && (
            <FormErrorMessage
              fontSize="14px"
              bg="red.500"
              color="white"
              position="absolute"
              left="0"
              right="0"
              top="100%"
              mt="0"
              px={2}
              rounded="5"
              fontWeight="bold"
            >
              {meta.error}
            </FormErrorMessage>
          )}
          {formFileUploads ? (
            <HStack fontSize="sm">
              <Tag fontSize="16px" fontWeight="bold" colorScheme="green">
                File Uploaded!
              </Tag>
              <Button
                colorScheme="red"
                variant="ghost"
                size="xs"
                onClick={() => setFormFileUploads(false)}
              >
                Remove File
              </Button>
            </HStack>
          ) : (
            <input
              {...input}
              onChange={({
                target: {
                  validity,
                  files: [file],
                },
              }) => {
                if (validity.valid) {
                  mutate({
                    variables: {
                      file,
                    },
                  });
                }
              }}
            />
          )}
        </FormControl>
      )}
    </Field>
  );
};

export default FileUpload;
